// extracted by mini-css-extract-plugin
module.exports = {"custom_img":"CourseSlider_custom_img__p1YPK","unset_img":"CourseSlider_unset_img__P50D_"};